// extracted by mini-css-extract-plugin
module.exports = {"error-fallback":"ErrorFallbackView_error-fallback__J-G5G","additional-message":"ErrorFallbackView_additional-message__2uwpH"};